import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-672299ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modale-overlay" }
const _hoisted_2 = { class: "modale-card d-flex flex-column p-4" }
const _hoisted_3 = { class: "modale-title mb-3" }
const _hoisted_4 = { class: "d-flex flex-row justify-content-between my-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modale-text" }, "Mot de passe temporaire", -1))
const _hoisted_6 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modale-text" }, "Nouveau mot de passe", -1))
const _hoisted_8 = { class: "d-flex flex-row justify-content-between my-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modale-text" }, "Confirmation", -1))
const _hoisted_10 = {
  key: 0,
  class: "error-text"
}
const _hoisted_11 = { class: "d-flex flex-row justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.message), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-control mg-input width-password",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldPassword) = $event))
        }, null, 512), [
          [_vModelText, _ctx.oldPassword]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-control mg-input width-password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-control mg-input width-password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event))
        }, null, 512), [
          [_vModelText, _ctx.confirmPassword]
        ])
      ]),
      (_ctx.errorMessage !== '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary modale-button mx-2",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validation && _ctx.validation(...args)))
        }, _toDisplayString(_ctx.textButtonValidation), 1),
        (_ctx.textButtonCancel)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-secondary modale-button cancel-button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, _toDisplayString(_ctx.textButtonCancel), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}